import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { BdGuardService } from './bd-redirect-guard.service';

export const bdGuard: CanActivateFn = () => inject(BdGuardService).canActivate();
